import React from 'react';
import { bool, string } from 'prop-types';
import classNames from 'classnames';

import css from './IconArrow.module.css';

const IconArrow = props => {
  const { className, rootClassName, isOpen } = props;
  const classes = classNames(rootClassName || css.root, className, {
    [css.open]: isOpen,
  });

  return (
    <svg className={classes} xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none">
      <path
        className={css.stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="m4.5 6.75 4.5 4.5 4.5-4.5"
      />
    </svg>
  );
};

IconArrow.defaultProps = {
  className: null,
  rootClassName: null,
  isOpen: true,
};

IconArrow.propTypes = {
  className: string,
  rootClassName: string,
  isOpen: bool,
};

export default IconArrow;
